export default "__VITE_ASSET__BYICpU2D__"